import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconAudioSettings$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAudioSettings extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '10519ceff13a9b88c5a12b210e48920142857773', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1b99dc97fa41812db965d08b3720c08c5bc37914', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '65231248ed4d8441a75ca580c3c62c2d3c187473', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 18.65a7.65 7.65 0 1 0 0-15.3 7.65 7.65 0 0 0 0 15.3M11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18", fill: "currentColor" }), h("path", { key: '4a65bf8f1dcc778ab127a180a5e84f58a5041bf3', d: "M5.5 9.5A.5.5 0 0 1 6 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5zm2.5-3a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm2.5 2A.5.5 0 0 1 11 8h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5zm2.5-1a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zm2.5 2A.5.5 0 0 1 16 9h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H16a.5.5 0 0 1-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-audio-settings", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-audio-settings"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-audio-settings":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAudioSettings$1);
            }
            break;
    } });
}

const CosmosIconAudioSettings = CosmosIconAudioSettings$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAudioSettings, defineCustomElement };
